import React from "react";

export const ToastUndo = ({ id, undo, closeToast }) => (
  <div>
    <h3>
      Feature Deleted{" "}
      <button
        onClick={() => {
          undo();
          closeToast();
        }}
      >
        UNDO
      </button>
    </h3>
  </div>
);
